export default __webpack_public_path__ + "static/media/red-felt.4ef9bdf3.webp";